const getCookie = (name) => {
  const strCookie = document?.cookie || '';
  const cookieList = strCookie.split(';');
  for (let i = 0; i < cookieList.length; i++) {
    const cookie = cookieList[i];
    const cookieArr = cookie.split('=');
    if (cookieArr.length > 0) {
      if (cookieArr[0].trim() === name) {
        return cookieArr.length > 1 ? cookieArr[1] : '';
      }
    }
  }
  return null;
};

const setCookie = (name, value) => {
  if (window?.document) {
    const d = new Date();
    // 目前先不做cid过期逻辑，
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    window.document.cookie = name + '=' + value + ';' + expires;
  } else {
    const docCallback = () => {
      if (window?.document?.readyState === 'interactive' || window?.document?.readyState === 'complete') {
        window?.document?.removeEventListener('readystatechange', docCallback);
        window?.document?.removeEventListener('DOMContentLoaded', docCallback);
        setCookie(name, value);
      }
    };
    window?.document?.addEventListener('readystatechange', docCallback);
    window?.document?.addEventListener('DOMContentLoaded', docCallback);
  }
};

const removeCookie = (name) => {
  if (window?.document) {
    const d = new Date();
    d.setTime(d.getTime() - 1000);
    const expires = 'expires=' + d.toUTCString();
    window.document.cookie = name + '=;' + expires;
  } else {
    const crCallback = () => {
      if (window?.document?.readyState === 'interactive' || window?.document?.readyState === 'complete') {
        window?.document?.removeEventListener('readystatechange', crCallback);
        window?.document?.removeEventListener('DOMContentLoaded', crCallback);
        removeCookie(name);
      }
    };
    window?.document?.addEventListener('readystatechange', crCallback);
    window?.document?.addEventListener('DOMContentLoaded', crCallback);
  }
};

export { getCookie, setCookie, removeCookie };
